import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { debounce } from 'lodash'
import { useTranslation } from 'react-i18next'

import FeaturedTable from '../FeaturedTable/FeaturedTable'
import { getClientsWithCount } from '../../reducers/clientsReducer'

import { getClientsListColumns } from './helpers'

const ClientsTable = ({
  searchValue,
  buildingId,
  selectedBuilding,
  showOnPage,
  pageNumber,
  clients,
  selectClient,
  getClientsWithCount,
  filter,
  setPaginationItemsCount,
  setSiteLoading,
}) => {
  const { t } = useTranslation(['clients-legacy', 'clients'])
  const [prevSearchValue, setPrevSearchValue] = useState('')

  const fetchClients = async (skip, searchingQuery, buildingId, filter) => {
    if (!buildingId) return
    try {
      const data = await getClientsWithCount(
        skip,
        buildingId,
        0,
        searchingQuery || '',
        showOnPage,
        filter,
      )
      setPaginationItemsCount(data.count)
    } catch (err) {
      console.log(err)
    }
  }

  const debounceFn = debounce(fetchClients, 1000)

  useEffect(() => {
    if (prevSearchValue !== searchValue) {
      debounceFn(undefined, searchValue, buildingId, filter)
    }
    setPrevSearchValue(searchValue)
  }, [searchValue])

  useEffect(() => {
    if (buildingId) {
      setSiteLoading(true)
      fetchClients(pageNumber, searchValue, buildingId, filter)
    }
  }, [pageNumber, selectedBuilding, showOnPage, filter])

  return (
    <div className="ctp-clients-main-table">
      {selectedBuilding && selectedBuilding.timezone && (
        <FeaturedTable
          onRowClick={(row) => selectClient(row.original)}
          columns={getClientsListColumns(selectedBuilding.timezone, t)}
          data={clients}
        />
      )}
    </div>
  )
}

ClientsTable.propTypes = {
  searchValue: PropTypes.string,
  buildingId: PropTypes.number,
  selectedBuilding: PropTypes.object,
  showOnPage: PropTypes.number,
  pageNumber: PropTypes.number,
  clients: PropTypes.array,
  selectClient: PropTypes.func,
  getClientsWithCount: PropTypes.func,
  filter: PropTypes.string,
  setPaginationItemsCount: PropTypes.func,
  setSiteLoading: PropTypes.func,
}

export default connect(
  () => {
    return {}
  },
  {
    getClientsWithCount,
  },
)(ClientsTable)
